// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 274 ? "152ccbd5" : chunkId) + "." + {"274":"738c1acc328e0c5e","856":"4f4905345fe15256"}[chunkId] + ".js";
};